import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  message: null,
  messageType: null,
  showMessage: false,
  viewMore: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const inspectiionSlice = createSlice({
  name: "inspection",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // organizations loader
    inspectionListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    inspectionList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    setViewMoreValue: (state, action) => {
      state.viewMore = action.payload;
    },
  },
});
